import nav from './nav';
import countUp from './count-up';

export default class App {
  initCore() {
    nav.hamburger();
    countUp.init();
  }
}

function LoadApp() {
  const app = new App();
  app.initCore();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', LoadApp);
} else {
  LoadApp();
}
